import PageAnalytics from "./PageAnalytics";

export default PageAnalytics;
export type { PageAnalyticsProps } from "./PageAnalytics";
